export default __webpack_public_path__ + "static/Jonathan_PhotoMontage-0f5f6ce169abb2cedc5b0d248fd1fe5f.png";